<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  name: string
  title?: string | null
  bio?: string | null
}

const props = defineProps<Props>()

const authorName = computed(() => props.name.trim() || 'QxAIOS Team')
const authorTitle = computed(() => props.title?.trim() || null)
const authorBio = computed(() => props.bio?.trim() || null)
</script>

<template>
  <section
    class="rounded-2xl border border-spruce-100 bg-white p-6 shadow-sm"
    aria-labelledby="blog-author-heading"
  >
    <h2
      id="blog-author-heading"
      class="text-lg font-semibold text-gray-900"
    >
      About the author
    </h2>
    <p class="mt-2 text-base font-semibold text-spruce-900">
      {{ authorName }}
    </p>
    <p
      v-if="authorTitle"
      class="text-sm text-gray-600"
    >
      {{ authorTitle }}
    </p>
    <p
      v-if="authorBio"
      class="mt-3 text-sm leading-6 text-gray-700"
    >
      {{ authorBio }}
    </p>
  </section>
</template>
